/**
 * wayai whoami — show the authenticated identity
 *
 * Usage:
 *   wayai whoami          # human-readable output
 *   wayai whoami --json   # structured output for agents/scripts
 */

import { requireAuth } from '../lib/auth.js';
import { ApiClient } from '../lib/api-client.js';

export function parseArgs(args: string[]): { json: boolean } {
  return { json: args.includes('--json') };
}

export async function whoamiCommand(args: string[]): Promise<void> {
  const { json } = parseArgs(args);
  const { config, accessToken } = await requireAuth();
  const client = new ApiClient({ apiUrl: config.api_url, accessToken });

  const me = await client.me();

  if (json) {
    console.log(JSON.stringify(me, null, 2));
    return;
  }

  console.log(`email:             ${me.email || '(unknown)'}`);
  console.log(`user_id:           ${me.user_id}`);
  console.log(`org_id:            ${me.org_id ?? '(none)'}`);
  console.log(`is_platform_admin: ${me.is_platform_admin}`);
  if (me.is_platform_admin) {
    console.log('\nPlatform-admin diagnostics available: `wayai admin`');
  }
}
